
import { Product } from "@/models/base";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			toUploadFiles: [] as File[],
			sending: false
		};
	},
	props: {
		product: {
			type: Object as () => Product,
			required: true
		}
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
